import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 24px 12px 32px;
  }
`;

export const Header = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  h1 {
    font-size: 1.5rem;
    color: #333;
    margin: 0;
  }
`;

export const PlansScroll = styled.div`
  overflow-x: auto;
  max-width: 100%;
  padding: 16px 0;

  &::-webkit-scrollbar {
    height: 8px;
    background: #f3f3f3;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 8px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  th {
    background: #f5f5f5;
    color: #555;
    text-align: left;
    padding: 12px;
    font-weight: 600;
    font-size: 1rem;
  }

  td {
    padding: 12px;
    font-size: 0.95rem;
    color: #333;
  }

  tr:nth-child(even) {
    background: #f9f9f9;
  }

  tr:hover {
    background: #f1f1f1;
  }
`;

export const PlanCard = styled.div`
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  padding: 32px 28px 28px 28px;
  min-width: 300px;
  max-width: 330px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid #e7e7e7;
  position: relative;
  transition: box-shadow .2s, border .2s;
  &.highlight {
    border: 2.5px solid #ba824f;
    box-shadow: 0 6px 24px rgba(186,130,79,0.13);
  }
`;

export const BestSeller = styled.div`
  position: absolute;
  top: -22px;
  left: 50%;
  transform: translateX(-50%);
  background: #fffbe9;
  color: #ba824f;
  border-radius: 18px;
  font-size: 1rem;
  font-weight: 700;
  padding: 6px 30px 6px 18px;
  box-shadow: 0 2px 8px rgba(186,130,79,0.10);
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 2;
  white-space: nowrap;
  min-width: 140px;
  justify-content: center;
  letter-spacing: 0.01em;
  line-height: 1.1;
  &::after {
    content: '';
    display: inline-block;
    margin-left: 10px;
    width: 18px; height: 18px;
    background: url('data:image/svg+xml;utf8,<svg fill="%23ba824f" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>') no-repeat center/contain;
  }
`;

export const PlanButton = styled.button`
  background: #ba824f;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 8px 16px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(186,130,79,0.09);
  transition: background .2s;
  &:hover { background: #a56e36; }
`;

export const PackageRow = styled.div`
  width: 100%;
  background: ${props => props.active
    ? 'linear-gradient(90deg, #f6fff8 60%, #e9fbe9 100%)'
    : 'linear-gradient(90deg, #fdf7f7 60%, #ffeaea 100%)'};
  border-radius: 15px;
  box-shadow: 0 4px 24px rgba(52,87,74,0.10);
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  min-height: 72px;
  margin-bottom: 22px;
  transition: box-shadow .22s, transform .18s;
  position: relative;
  word-break: break-word;

  @media (max-width: 900px) {
    align-items: flex-start;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 18px;
  border-radius: 16px;
  font-size: 1.02rem;
  font-weight: 700;
  background: ${props => props.active ? 'linear-gradient(90deg, #e3fbe3 60%, #b4f2b4 100%)' : 'linear-gradient(90deg, #ffeaea 60%, #ffd6d6 100%)'};
  color: ${props => props.active ? '#2e7031' : '#b71c1c'};
  border: 1.5px solid ${props => props.active ? '#388e3c44' : '#c6282844'};
  box-shadow: 0 1px 6px ${props => props.active ? '#388e3c11' : '#c6282811'};
  letter-spacing: 0.01em;
  transition: background .2s, color .2s;
  white-space: nowrap;
`;

export const PackageCell = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  font-weight: 500;
  color: #34574A;
  position: relative;
`;

export const PackageLabel = styled.span`
  font-size: 0.88rem;
  color: #8e8e8e;
  font-weight: 400;
  margin-right: 3px;
  letter-spacing: 0.01em;
`;

export const PackageValue = styled.span`
  font-size: 1.08rem;
  font-weight: 700;
  color: #34574A;
`;

export const IconCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${props => props.color || '#f3f3f3'};
  color: #fff;
  font-size: 1.2rem;
`;

export const PackageActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    justify-content: flex-start;
  }
`;

export const RenewButton = styled.button`
  background: linear-gradient(90deg,#ba824f 60%,#e0b07c 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 28px;
  font-weight: 700;
  font-size: 1.04rem;
  cursor: pointer;
  box-shadow: 0 2px 10px #ba824f22;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background .18s, box-shadow .18s, transform .15s;
  &:hover { background: linear-gradient(90deg,#a56e36 60%,#cfa169 100%); box-shadow: 0 5px 18px #ba824f33; transform: scale(1.04); }
`;

export const DetailsButton = styled(RenewButton)`
  background: linear-gradient(90deg,#34574A 60%,#568e7c 100%);
  &:hover { background: linear-gradient(90deg,#274137 60%,#34574A 100%); }
`;

export const PackagesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  width: 100%;
  min-height: 180px;
  align-items: flex-start;
`;

export const SectionBox = styled.div`
  width: 100%;
  border: 2px solid #e7e7e7;
  border-radius: 13px;
  background: #fafbfa;
  padding: 26px 32px 32px 32px;
  margin-bottom: 32px;
`;

export const PlansHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;

  h2 {
    font-size: 1.2rem;
    margin: 0;
    color: #34574A;
  }

  .tabs-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  @media (max-width: 600px) {
    .tabs-row {
      justify-content: space-between;
    }

    .tabs-row button {
      flex: 1 1 30%;
      min-width: 0;
    }
  }
`;

export const DetailsModalOverlay = styled.div`
  position: fixed; left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.28);
  z-index: 1200;
  display: flex; align-items: center; justify-content: center;
`;
export const DetailsModalBox = styled.div`
  background: #fff; border-radius: 14px; min-width: 350px; max-width: 95vw;
  box-shadow: 0 8px 32px rgba(52,87,74,0.18);
  padding: 36px 40px 30px 40px; position: relative;
`;
export const CloseModalBtn = styled.button`
  position: absolute; top: 16px; right: 18px; background: none; border: none;
  font-size: 1.6rem; color: #aaa; cursor: pointer; transition: color .18s;
  &:hover { color: #ba824f; }
`;

export const AlertOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
`;

export const AlertBox = styled.div`
  background: #ffffff;
  border-radius: 14px;
  padding: 32px 36px;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.16);
  max-width: 480px;
  width: 92%;
  text-align: center;
  border: 1px solid #e5e7eb;
`;

export const AlertTitle = styled.h3`
  margin: 0 0 14px;
  font-size: 1.8rem;
  color: #3b3b3b;
  letter-spacing: 0.01em;
`;

export const AlertDescription = styled.p`
  margin: 0 0 22px;
  color: #4b5563;
  line-height: 1.55;
  font-size: 1rem;
`;

export const AlertOkButton = styled.button`
  background: #34574A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: transform 0.18s, box-shadow 0.18s, background 0.18s;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.18);
  }
`;